// removed by extract-text-webpack-plugin
module.exports = {"text800":"_1Ume6qXB8CzO4gJpINTV7b","text700":"ObQ7QMYTHnGm57R2kvP4f","text600":"_1BDhF_5lv22-rDvX18OkCC","text500":"uLy5CaU7mALX80_jv3aRG","text400":"_2sUgFiMKXWrebH72dR2zpA","message":"_37Jz96xgAiM1sjcCgicyaB","text300":"_39VAFcydrXHgqkWT1GREha","text200":"_1JHq5xeh971oNiN8mHP_wC","textParagraph":"_2ZL4em-bp97d0dYR0OK5dh","crimp":"_162-yvcU45fEOue77rRr92","trim":"gCWDll2HvZtyG8EKkgsjp","flexCenter":"_3vFafRLicnUKJq0mlwOCFY","wrapper":"_3BrDT1q25gBE6YEtt06L3a","hideTextOverflow":"_1i0Q47dVZ89qPZwd3PV_B2","marginPageMainContent":"_10vRszgBSr1IHNTHaFydip"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageWait/styles.scss
// module id = 630
// module chunks = 0